import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

export const PUBLICATION_CHANNELS = [
  'LinkedIn',
  'Blog',
  'Newsletter',
  'Facebook',
  'X',
  'Youtube',
  'Instagram',
] as const;

export type PublicationChannel = (typeof PUBLICATION_CHANNELS)[number];

interface Props {
  value: string[];
  onChange: (next: string[]) => void;
}

export function ChannelsPicker({ value, onChange }: Props) {
  const toggle = (channel: string, checked: boolean) => {
    if (checked) {
      if (!value.includes(channel)) onChange([...value, channel]);
    } else {
      onChange(value.filter((c) => c !== channel));
    }
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
      {PUBLICATION_CHANNELS.map((c) => {
        const id = `channel-${c}`;
        const checked = value.includes(c);
        return (
          <label
            key={c}
            htmlFor={id}
            className={`flex items-center gap-2 px-3 py-2 rounded-md border cursor-pointer transition-colors ${
              checked ? 'bg-blue-50 border-blue-300' : 'bg-white border-slate-200 hover:border-slate-300'
            }`}
          >
            <Checkbox
              id={id}
              checked={checked}
              onCheckedChange={(v) => toggle(c, Boolean(v))}
            />
            <Label htmlFor={id} className="text-sm cursor-pointer">{c}</Label>
          </label>
        );
      })}
    </div>
  );
}
